module.exports = __webpack_public_path__ + "static/media/S2N4-3.8632ab43.svg";